import { render, staticRenderFns } from "./TabelaProcessosJudiciaisPj.vue?vue&type=template&id=1a85bc20&lang=pug"
import script from "./TabelaProcessosJudiciaisPj.vue?vue&type=script&lang=js"
export * from "./TabelaProcessosJudiciaisPj.vue?vue&type=script&lang=js"
import style0 from "./TabelaProcessosJudiciaisPj.vue?vue&type=style&index=0&id=1a85bc20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports